import { render, staticRenderFns } from "./raise-tab.vue?vue&type=template&id=5dedee57&scoped=true&"
import script from "./raise-tab.vue?vue&type=script&lang=js&"
export * from "./raise-tab.vue?vue&type=script&lang=js&"
import style0 from "./raise-tab.vue?vue&type=style&index=0&id=5dedee57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dedee57",
  null
  
)

export default component.exports